import { render, staticRenderFns } from "./TrialBanner.vue?vue&type=template&id=987c038a&scoped=true&"
import script from "./TrialBanner.vue?vue&type=script&lang=js&"
export * from "./TrialBanner.vue?vue&type=script&lang=js&"
import style0 from "./TrialBanner.vue?vue&type=style&index=0&id=987c038a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987c038a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987c038a')) {
      api.createRecord('987c038a', component.options)
    } else {
      api.reload('987c038a', component.options)
    }
    module.hot.accept("./TrialBanner.vue?vue&type=template&id=987c038a&scoped=true&", function () {
      api.rerender('987c038a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Billings/TrialBanner.vue"
export default component.exports